var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignedUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00074 4.67555C10.4227 4.67555 11.5792 3.62672 11.5792 2.33777C11.5792 1.04883 10.4225 0 9.00074 0C7.57898 0 6.42188 1.04864 6.42188 2.33777C6.42188 3.62691 7.57877 4.67555 9.00074 4.67555Z",
    fill: "#0277BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3827 4.77148C10.7475 5.28277 9.91442 5.59629 9.00019 5.59629C8.08574 5.59629 7.25268 5.28277 6.61747 4.77148C5.6375 5.09209 4.93359 5.94143 4.93359 6.93909V11.9996H13.0664V6.93909C13.0666 5.94143 12.3629 5.09209 11.3827 4.77148Z",
    fill: "#0277BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6507 4.75445C4.89512 4.75445 5.90933 3.85242 5.94527 2.73192C5.92794 2.60257 5.91631 2.47168 5.91631 2.33811C5.91631 2.33792 5.91631 2.33792 5.91631 2.33772C5.73938 1.34735 4.79217 0.587891 3.65049 0.587891C2.38325 0.587891 1.35254 1.5225 1.35254 2.67117C1.35275 3.82003 2.38367 4.75445 3.6507 4.75445Z",
    fill: "#0277BD",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5412 4.98828C0.635842 5.34166 0 6.15803 0 7.10682V10.9526H4.42849V6.94087C4.42849 6.41502 4.57075 5.91983 4.81764 5.48079C4.45385 5.60535 4.06173 5.67683 3.65038 5.67683C2.84987 5.67664 2.11468 5.41793 1.5412 4.98828Z",
    fill: "#0277BD",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0557 2.73077C12.091 3.85185 13.1054 4.75445 14.35 4.75445C15.6173 4.75445 16.648 3.81984 16.648 2.67117C16.648 1.5225 15.6171 0.587891 14.35 0.587891C13.2079 0.587891 12.2603 1.3483 12.0842 2.33964C12.0844 2.47206 12.073 2.60218 12.0557 2.73077Z",
    fill: "#0277BD",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4591 4.98828C15.8856 5.41812 15.1504 5.67664 14.3499 5.67664C13.9387 5.67664 13.5464 5.60516 13.1826 5.4806C13.4295 5.91964 13.5718 6.41502 13.5718 6.94087V10.9526H18.0003V7.10682C18.0003 6.15803 17.3644 5.34166 16.4591 4.98828Z",
    fill: "#0277BD",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedUpIcon);
export default __webpack_public_path__ + "static/media/signed-up-icon.62159586f75391fa1f76d789aa04c6fe.svg";
export { ForwardRef as ReactComponent };